import { trackEvent } from "@utils/api/tracker";
import { saveSurveyAnswers } from "src/utils/redux/slices/userData";
import { captureException } from "src/utils/sentry";
import {
  isBuildPlanEligible,
  isInAppWebPurchaseEligible,
} from "src/utils/userSegment/features";
import goto from "src/pageDefinitions/goto";
import { isInApp } from "src/utils/userSegment";
import { ActionHandlerParams } from "..";
import { getPageSetSurvey } from "./util";
import { trackViewContentWithParamsExsf0 } from "src/utils/services/ConversionTracker";

const PAYMENT_SURVEY_NAMESPACE = "purchaseSurveyAnswers";

type Params = {
  finishedEvent?: string;
  lead?: string;

  dateKey?: string;
  extraProps?: JsonObject;
};

export const onCompletePaymentSurvey = async ({
  params = {},
  store,
  pageSet,
  page,
}: {
  params?: Params;
} & ActionHandlerParams) => {
  const survey = getPageSetSurvey(pageSet, page);
  const finishedEvent = params.finishedEvent || `Finished${survey.name}`;

  const { surveyAnswers } = store.getState();
  try {
    await store.dispatch(
      saveSurveyAnswers(surveyAnswers, {
        surveyNameSpace: PAYMENT_SURVEY_NAMESPACE,
        dateKey: "purchaseSurveyCompleteDateISO",
      })
    );

    trackEvent(finishedEvent, surveyAnswers);
    trackViewContentWithParamsExsf0({
      content_type: `FBMG-${finishedEvent}`,
    });

    // TODO: Put this all into the page set
    if (isInApp() && !isInAppWebPurchaseEligible()) {
      goto.nativePurchase();
    } else if (isBuildPlanEligible()) {
      goto.buildPlan();
    } else {
      goto.account();
    }
    // End Pageset
  } catch (e) {
    // TODO: Tag and throw or log and throw?
    captureException(e, "onCompletePurchaseSurvey");
    throw e;
  }
};
